import React from "react";

import Messages from "core/Messages";
import {
    UnstyledDownloadMessage,
    DownloadMessageSecondaryText
} from "./styles";

const DownloadMessage = ({ children }) => (
    <UnstyledDownloadMessage>
        <Messages infoType="success" darkMode>
            Ready for download
        </Messages>
        <DownloadMessageSecondaryText>{children}</DownloadMessageSecondaryText>
    </UnstyledDownloadMessage>
);

export default DownloadMessage;
